export const getPrimaryTaxonomy = (
  terms: { name: string; primary: boolean; slug: string }[]
) => terms.find((term) => term.primary === true);
